(function(){
var toast=document.getElementById('toast'),tm;
function say(t){if(!toast)return;toast.textContent=t;toast.classList.add('show');clearTimeout(tm);tm=setTimeout(function(){toast.classList.remove('show')},1800);}
function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=n});}
// burger
var bg=document.querySelector('.burger'),nav=document.getElementById('mainnav');
if(bg&&nav)bg.addEventListener('click',function(){var o=nav.classList.toggle('open');bg.setAttribute('aria-expanded',String(o));});
// hero sound + slides
document.querySelectorAll('.sound').forEach(function(b){
 var v=b.closest('.slide').querySelector('video'),l=b.querySelector('.sr'),x=b.querySelector('.spkx'),w=b.querySelector('.spkw');
 b.addEventListener('click',function(){v.muted=!v.muted;if(!v.muted){v.volume=.8;v.play();}b.setAttribute('aria-pressed',String(!v.muted));l.textContent=v.muted?'Sound on':'Sound off';x.style.display=v.muted?'':'none';w.style.display=v.muted?'none':'';});
});
document.querySelectorAll('[data-hero]').forEach(function(h){
 var s=h.querySelectorAll('.slide'),d=h.querySelectorAll('.dots button'),i=0,iv=+h.dataset.interval,t;
 if(s.length<2)return;
 function go(n){i=(n+s.length)%s.length;s.forEach(function(e,k){e.classList.toggle('on',k===i);var v=e.querySelector('video');if(v){if(k===i)v.play();else{v.pause();v.muted=true;}}});d.forEach(function(e,k){e.classList.toggle('on',k===i)});if(iv){clearTimeout(t);t=setTimeout(function(){go(i+1)},iv*1000);}}
 d.forEach(function(e,k){e.addEventListener('click',function(){go(k)})});
 if(iv)t=setTimeout(function(){go(1)},iv*1000);
});
// product rail
document.querySelectorAll('[data-rail]').forEach(function(r){
 var tr=r.querySelector('[data-track]'),dots=r.querySelector('[data-dots]');
 function pages(){return Math.max(1,Math.round(tr.scrollWidth/tr.clientWidth));}
 function page(){return Math.round(tr.scrollLeft/tr.clientWidth);}
 function draw(){var n=pages(),p=page();dots.innerHTML='';if(n<2)return;for(var k=0;k<n;k++){var b=document.createElement('b');if(k===p)b.className='on';dots.appendChild(b);}}
 r.querySelector('[data-prev]').addEventListener('click',function(){tr.scrollBy({left:-tr.clientWidth,behavior:'smooth'})});
 r.querySelector('[data-next]').addEventListener('click',function(){tr.scrollBy({left:tr.clientWidth,behavior:'smooth'})});
 tr.addEventListener('scroll',function(){clearTimeout(tr._t);tr._t=setTimeout(draw,80)});
 window.addEventListener('resize',draw);draw();
});
// add to basket
document.querySelectorAll('[data-demo]').forEach(function(b){b.addEventListener('click',function(){say(b.dataset.title+' is a sample product');});});
document.querySelectorAll('form[data-add]').forEach(function(f){
 f.addEventListener('submit',function(e){
  if(e.submitter&&e.submitter.name==='checkout')return;
  e.preventDefault();
  fetch(window.CF.add,{method:'POST',body:new FormData(f),headers:{Accept:'application/json'}})
  .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||'Could not add to basket');return j;});})
  .then(function(){say((f.dataset.title||'Item')+' added to basket');return fetch(window.CF.cart).then(function(r){return r.json()});})
  .then(function(c){setCount(c.item_count)})
  .catch(function(err){say(err.message)});
 });
});
// product gallery
var ms=document.getElementById('mainshot');
document.querySelectorAll('[data-shot]').forEach(function(b){b.addEventListener('click',function(){ms.src=b.dataset.shot;});});
})();
